// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ClockFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from clock-filled.svg
 */
export default function ClockFilledIcon(props: ClockFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ClockFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M16 8c0-4.052-3.948-8-8-8S0 3.948 0 8s3.948 8 8 8 8-3.948 8-8M9 4a1 1 0 1 0-2 0v4a1 1 0 0 0 .445.832l3 2a1 1 0 0 0 1.11-1.664L9 7.465z"
        />
      </g>
    </svg>
  );
}
